export default "__VITE_ASSET__DI9I1or8__"